import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CorporateAccountService, GeneralService, IUser } from '@clooper/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-extra-service-airport',
  templateUrl: './extra-service-airport.component.html',
  styleUrls: ['./extra-service-airport.component.scss']
})
export class ExtraServiceAirportComponent implements OnInit {
  user: IUser | undefined

  form = new FormGroup({
    airport_location: new FormControl('', [Validators.required]),
    number_of_travelers: new FormControl('', [Validators.required]),
    additional_requests: new FormControl('', []),
    vehicle_type: new FormControl('', [Validators.required]),
  });
  locationName: any;
  booking: any;

  loading: boolean = false

  constructor(
    public bsModalRef: BsModalRef,
    private options: ModalOptions,
    private service: CorporateAccountService,
    private toastr: ToastrService,
    private gs: GeneralService,


  ) { }

  ngOnInit(): void {
    this.user = this.options.initialState?.user as IUser

    this.booking = this.options.initialState?.booking

  }

  locationChangeF({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    this.form.controls.airport_location.setValue(s);

  }

  locationChangeT({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    this.form.controls.departure_airport.setValue(s);

  }

  locationChangeJ({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    this.form.controls.airport_location.setValue(s);

  }

  submit() {
    this.loading = true
    const {airport_location, additional_requests, number_of_travelers, destination, vehicle_type} = this.form.value;

    const payload = {
      airport_location,
      additional_requests,
      number_of_travelers,
      // destination,
      // vehicle_type,
      employee: this.user?.id || this.user?._id,
      business: this.user?.business?.id || this.user?.business?._id,
      booking: this.booking

    }
    if (this.booking !== null) {
      this.service.createExtraServiceAirportLounge(payload).subscribe((res: any) => {
          this.toastr.success(res.message)
          this.bsModalRef.hide()
      }, err => {
        this.toastr.error(this.gs.getErrMsg(err));
        this.loading = false

      })
    } else {
      delete payload.booking
      this.service.createExtraServiceAirportLounge(payload).subscribe((res: any) => {
        this.toastr.success(res.message)
        this.bsModalRef.hide()
      }, err => {
        this.toastr.error(this.gs.getErrMsg(err));
        this.loading = false

          // this.bsModalRef.hide()
      })

    }
  }

}
